<template>
<b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
  <b-card title="Utilisateurs">
    <b-button
        href='/users-creator/add'
        variant="primary"
      >
        + Ajouter un créateur
      </b-button>
    <!-- search input -->
    <div class="custom-search d-flex justify-content-end">
      <b-form-group>
        <div class="d-flex align-items-center">
          <label class="mr-1">Chercher</label>
          <b-form-input
            v-model="searchTerm"
            placeholder="Recherche"
            type="text"
            class="d-inline-block"
          />
        </div>
      </b-form-group>
    </div>
    <!-- table -->
    <vue-good-table
      :columns="columns"
      :rows="users"
      :pagination-options="{
        enabled: true,
        perPage:pageLength
      }"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm
      }"
    >
      <template
        slot="table-row"
        slot-scope="props"
      >

        <span v-if="props.column.field === 'action'">
          <span>
            <b-dropdown
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template v-slot:button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="text-body align-middle mr-25"
                />
              </template>

               <b-dropdown-item  @click="$router.push({name:'seeProfileCreator', params: { id: props.row.id }})">
                <feather-icon
                  icon="ZoomInIcon"
                  class="mr-50"
                />
                <span>Voir les details</span>
              </b-dropdown-item>
           
              <b-dropdown-item  @click="$router.push({name:'editUserCreator', params: { id: props.row.id }})">
                <feather-icon
                  icon="Edit2Icon"
                  class="mr-50"
                />
                <span>Modifier le catalogue</span>
              </b-dropdown-item>

              <b-dropdown-item  @click="$router.push({name:'editProfileCreator', params: { id: props.row.id }})">
                <feather-icon
                  icon="Edit2Icon"
                  class="mr-50"
                />
                <span>Modifier le profil</span>
              </b-dropdown-item>

              <b-dropdown-item  @click="$router.push({name:'createTransfer', params: { id: props.row.id }})">
                <feather-icon
                  icon="DollarSignIcon"
                  class="mr-50"
                />
                <span>Effectuer un virement</span>
              </b-dropdown-item>
             
             
               
              <b-dropdown-item v-b-modal.modal-danger @click="selectedItem=props.row.id">
                <feather-icon
                  icon="TrashIcon"
                  class="mr-50"
                />
                <span>Supprimer</span>
              </b-dropdown-item>
            </b-dropdown>
          </span>
        </span>
       
        <span v-else-if="props.column.field === 'created_at.date'">
          <span v-if="props.formattedRow[props.column.field]">
            {{new Date(props.formattedRow[props.column.field]).toLocaleDateString("fr")}}
          </span>
        </span>
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>
      <template
        slot="pagination-bottom"
        slot-scope="props"
      >
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap ">
              Page 1 de
            </span>
            <b-form-select
              v-model="pageLength"
              :options="['3','5','10']"
              class="mx-1"
              @input="(value)=>props.perPageChanged({currentPerPage:value})"
            />
            <span class="text-nowrap"> sur {{ props.total }} résultats </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value)=>props.pageChanged({currentPage:value})"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </div>
        </div>
      <b-modal
          id="modal-danger"
          cancel-variant="outline-secondary"
          cancel-title="Non"
          ok-variant="danger"
          ok-title="Oui"
          @ok="deleteUser(selectedItem)"
          modal-class="modal-danger"
          centered
          title="Êtes-vous sûr ?"
        >
          <b-card-text>
            Attention, cette action est irréversible ! Êtes-vous sûr de vouloir supprimer cet utilisateur ?
          </b-card-text>
        </b-modal>
      <b-modal
          id="modal-danger-admin"
          cancel-variant="outline-secondary"
          cancel-title="Non"
          ok-variant="danger"
          ok-title="Oui"
          @ok="setAdmin(selectedUser)"
          modal-class="modal-danger-admin"
          centered
          title="Êtes-vous sûr ?"
        >
          <b-card-text>
            Attention, cette action est irréversible ! Êtes-vous sûr de vouloir définir cet utilisateur comme administrateur ?
          </b-card-text>
        </b-modal>

         <b-modal
          id="modal-danger-admin-delete"
          cancel-variant="outline-secondary"
          cancel-title="Non"
          ok-variant="danger"
          ok-title="Oui"
          @ok="unsetAdmin(selectedUser)"
          modal-class="modal-danger-admin"
          centered
          title="Êtes-vous sûr ?"
        >
          <b-card-text>
            Attention, cette action est irréversible ! Êtes-vous sûr de vouloir supprimer cet utilisateur des administrateurs ?
          </b-card-text>
        </b-modal>
      </template>
    </vue-good-table>

  </b-card>
</b-overlay>
</template>

<script>
import {BModal, BButton, VBModal,BOverlay, BCard, BCardText, BAvatar, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem, } from 'bootstrap-vue'
import {APIRequest, Woocommerce,Auth} from '@simb2s/senseye-sdk'
import { VueGoodTable } from 'vue-good-table'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BCard,
    BCardText,
    VueGoodTable,
    BOverlay,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BModal,
    BButton
  },
  data() {
    return {
      users:[],
      pageLength: 10,
      totalRows:0,
      currentPage:1,
      loading:true,
      dir: false,
      selectedItem:null,
      columns: [
        {
          label: 'Nom',
          field: 'name',
        },
        {
          label: 'Prénom',
          field: 'surname',
        },
        {
          label: 'Email',
          field: 'email',
        },
        {
          label: 'Téléphone',
          field: 'phone',
        },
        {
          label: 'Inscrit le',
          field: 'created_at.date',
          dateInputFormat:'dd/MM/yyyy',
          formatFn: function (value) {
              return value != null ? value : null
          }
        },
        
        {
          label: 'Action',
          field: 'action',
        },
      ],
      rows: [],
      searchTerm: '',

    }
  },
  methods:{
     async unsetAdmin(id)
    {
      this.loading=true
      try {
        await Auth.unset_admin(id)
        this.users=await Auth.list_users_by_role('ROLE_CREATOR')
        this.loading=false
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "L'utilisateur a bien été retiré des administrateurs !",
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
        
      } catch (error) {
        this.loading=false
        
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Une erreur est survenue.',
            icon: 'AlertCircleIcon',
            variant: 'warning',
          },
        })
        
      }
    },
    async setAdmin(id)
    {
      this.loading=true
      try {
        await Auth.set_admin(id)
        this.users=await Auth.list_users_by_role('ROLE_CREATOR')
        this.loading=false
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "L'utilisateur a bien été défini comme administrateur !",
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
        
      } catch (error) {
        this.loading=false
        
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Une erreur est survenue.',
            icon: 'AlertCircleIcon',
            variant: 'warning',
          },
        })
        
      }
    },
    async deleteUser(id)
    {
      this.loading=true
      try {
        
        await Auth.delete(id)
        this.users=await Auth.list_users_by_role('ROLE_CREATOR')
        this.loading=false
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "L'utilisateur a bien été supprimé !",
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
        
      } catch (error) {
        this.loading=false
        
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Une erreur est survenue.',
            icon: 'AlertCircleIcon',
            variant: 'warning',
          },
        })
        
      }
    }
    
    
    
  },
  async mounted()
  {
  
    this.users=await Auth.list_users_by_role('ROLE_CREATOR')
    for(let i=0;i<this.users.length;i++) {
      if(this.users[i].main_user!=null) {
        this.users.splice(i, 1);
        i--
      }
    }
    this.loading=false
  }
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
